<template>
  <div class="p-20">
    <app-filter
      :filter-list="table_filter"
      default-label-width="100px"
      @search="search"
    />
    <div class="text-right mb-20">
      <el-button size="mini" type="success" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app_table_ref"
      :table-key="table_key"
      :tablep="table_params"
      :get-data="getWechatGamePlayablePageList"
      :table-props="{ 'max-height': '450px'}"
      :check="true"
      check-key="id"
      :is-reserve-checked="true"
      :is-row-click="true"
      @select-tr="selectionChange"
      @hook:mounted="onTableMounted"
    />
  </div>

</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { getWechatGamePlayablePageListApi, pullWechatGamePlayablePageApi } from '@/api/tool/wechat-game-playable-page';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 表单项配置 */
    formItem: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /** 投放内容ID */
    deliveryContentId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        page_size: 10,
        filtering: {
          delivery_content_id: this.deliveryContentId,
        },
      },
    };
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     * @returns {void}
     */
    search(params = {}) {
      Object.assign(this.table_params.filtering, params);
      this.$refs['app_table_ref'].seekTable();
    },
    /**
     * 获取初始化配置
     * @returns {Object}
     */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error){
        console.error(error);
        return {};
      }
    },
    /**
     * 获取微信小游戏试玩页列表
     * @param {Object} params 接口参数
     * @returns {Promise<Object>}
     */
    getWechatGamePlayablePageList(params) {
      const { channel_interface } = this.getInitConfig();
      return new Promise((resolve, reject) => {
        getWechatGamePlayablePageListApi({
          channel_interface,
          advertiser_id: this.advertiserId,
          ...params,
        }).then(res => {
          res.list = (res?.list || []).map(item => Object.assign(item, { advertiser_id: this.advertiserId }));
          resolve({ ...res });
        }).catch(reject);
      });
    },
    /**
     * 同步列表
     * @returns {void}
     */
    onPull() {
      const { channel_interface } = this.getInitConfig();
      pullWechatGamePlayablePageApi({
        channel_interface,
        advertiser_id: this.advertiserId,
        filtering: {
          delivery_content_id: this.deliveryContentId,
        },
      }).then(({ message }) => {
        this.$message.success(message || '同步成功');
        this.$refs['app_table_ref'].seekTable();
      });
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const app_table_ref = this.$refs.app_table_ref;
      const assign_selection = this.formItem.assignSelection[this.advertiserId] || [];
      app_table_ref.multipleSelection.splice(0);
      app_table_ref.multipleSelection.push(...assign_selection);
      app_table_ref.multipleSelectionAll.splice(0);
      app_table_ref.multipleSelectionAll.push(...assign_selection);
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     */
    selectionChange(rows) {
      if (rows?.length > 1) {
        this.$message.warning('仅允许选中1条数据');
        this.resetTableSelection();
        return;
      }

      if (!this.formItem.assignSelection[this.advertiserId]) {
        this.formItem.assignSelection[this.advertiserId] = [];
      }
      const assign_selection = this.formItem.assignSelection[this.advertiserId];
      assign_selection.splice(0);
      assign_selection.push(...rows);
    },
    /**
     * 重置表格选中
     * @returns {void}
     */
    resetTableSelection() {
      const app_table_ref = this.$refs.app_table_ref;
      const assign_selection = this.formItem.assignSelection[this.advertiserId] || [];

      app_table_ref?.$refs?.table?.clearSelection?.();

      app_table_ref?.multipleSelection?.splice(0);
      app_table_ref?.multipleSelection?.push(...assign_selection);
      app_table_ref?.multipleSelectionAll?.splice(0);
      app_table_ref?.multipleSelectionAll?.push(...assign_selection);

      app_table_ref?.selectedPreExisting?.(assign_selection);
    },
  },
};
</script>
